import { useState } from "react";
import { C } from "../data";
import Img from "./Img";
import Footer from "./Footer";

const DEFAULT_MAIN_CATS = ["All", "Top", "Bottom", "Outwear"];

const FILTER_LABELS = {
  All:     "All Products",
  Top:     "Tops",
  Bottom:  "Bottoms",
  Outwear: "Outwear",
  new:     "New Arrivals",
  best:    "Best Sellers",
};

const FILTER_SUB = {
  All:     "전체 컬렉션",
  Top:     "상의 컬렉션",
  Bottom:  "하의 컬렉션",
  Outwear: "아우터 컬렉션",
  new:     "신상품",
  best:    "베스트셀러",
};

export default function ShopPage({ products, filter, onGoDetail, onSetFilter, nav, navCats }) {
  const [hovCard, setHovCard] = useState(null);

  const mainCatList = navCats
    ? ["All", ...new Set(navCats.map(c => c.catFilter))]
    : DEFAULT_MAIN_CATS;
  const mainCatSet = new Set(mainCatList);

  const filtered = (() => {
    if (filter === "new")            return products.filter(p => p.tag === "NEW");
    if (filter === "best")           return products.filter(p => p.tag === "BEST");
    if (!filter || filter === "All") return products;
    if (mainCatSet.has(filter))      return products.filter(p => p.cat === filter);
    return products.filter(p => p.subcat === filter);
  })();

  const label = FILTER_LABELS[filter] || filter;
  const sub   = FILTER_SUB[filter]    || "";

  return (
    <>
      {/* PAGE HEADER */}
      <div style={{ paddingTop:'var(--header-h, 60px)', background:C.bg }}>
        <div style={{ maxWidth:1440, margin:"0 auto", padding:"56px 48px 40px", borderBottom:`1px solid ${C.border}` }}>
          <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:C.accent, marginBottom:10, textTransform:"uppercase" }}>
            Shop
          </p>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", flexWrap:"wrap", gap:16 }}>
            <div>
              <h1 style={{ fontFamily:"'DM Serif Display',serif", fontSize:"clamp(32px,5vw,60px)", fontWeight:400, lineHeight:1.05 }}>
                {label}
              </h1>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, fontWeight:300, color:C.muted, marginTop:8 }}>
                {sub} — {filtered.length}개 제품
              </p>
            </div>
            {/* 카테고리 필터 */}
            {(filter !== "new" && filter !== "best") && (
              <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
                {mainCatList.map(c => (
                  <button key={c} className={`cat-btn${filter === c ? " on" : ""}`} onClick={() => onSetFilter(c)}>{c}</button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* PRODUCT GRID */}
      <div style={{ maxWidth:1440, margin:"0 auto", padding:"48px 48px 96px" }}>
        {filtered.length === 0 ? (
          <div style={{ textAlign:"center", padding:"96px 0" }}>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:28, fontWeight:400, color:C.muted }}>
              등록된 제품이 없습니다.
            </p>
          </div>
        ) : (
          <div className="prod-grid" style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:2 }}>
            {filtered.map(p => (
              <div key={p.id} className="prod-card"
                onMouseEnter={() => setHovCard(p.id)}
                onMouseLeave={() => setHovCard(null)}
                onClick={() => onGoDetail(p.id)}>
                <div className="pimg" style={{ aspectRatio:"3/4" }}>
                  <div className="pimg-inner">
                    {p.imgs?.[0]
                      ? <img src={p.imgs[0]} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt={p.name} />
                      : <Img style={{ width:"100%", height:"100%" }} />
                    }
                  </div>
                  {p.tag && (
                    <div style={{ position:"absolute", top:12, left:12, background:p.tag==="BEST"?C.ink:C.accent, padding:"4px 10px" }}>
                      <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:8, letterSpacing:3, color:"#fff" }}>{p.tag}</span>
                    </div>
                  )}
                  <div style={{ position:"absolute", inset:0, border:hovCard===p.id?`2px solid ${C.accent}`:"2px solid transparent", transition:"border-color .25s", pointerEvents:"none" }} />
                </div>
                <div style={{ paddingTop:12 }}>
                  <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, color:hovCard===p.id?C.hover:C.ink, fontWeight:hovCard===p.id?700:400, transition:"color .25s", marginBottom:3 }}>{p.name}</p>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:C.accent, marginBottom:3, textTransform:"uppercase" }}>{p.cat}</p>
                  {p.discountRate > 0 ? (
                    <div style={{ display:"flex", alignItems:"baseline", gap:6 }}>
                      <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:12, color:C.ink, letterSpacing:1 }}>₩{Math.round(p.price * (1 - p.discountRate / 100)).toLocaleString()}</span>
                      <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:10, color:C.muted, letterSpacing:1, textDecoration:"line-through" }}>₩{p.price.toLocaleString()}</span>
                      <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:9, fontWeight:600, color:"#C0392B" }}>{p.discountRate}%</span>
                    </div>
                  ) : (
                    <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:12, color:C.ink, letterSpacing:1 }}>₩{p.price.toLocaleString()}</p>
                  )}
                  {(p.shippingFee ?? 0) === 0
                    ? <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:9, fontWeight:600, letterSpacing:1, color:"#3D8B5C", marginTop:3, display:"inline-block" }}>무료배송</span>
                    : <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:9, color:C.muted, marginTop:3, display:"inline-block" }}>배송비 ₩{parseInt(p.shippingFee).toLocaleString()}</span>
                  }
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer nav={nav} variant="full" />
    </>
  );
}
